import { apiService } from './apiService';
import ToastMe from '@/components/ui/ToastMe';

export function getDashboardService() {
    return apiService({
        method: 'GET',
        url: '/dashboard/data',
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
export function getOverviewService(data) {
    return apiService({
        method: 'POST',
        url: '/dashboard/overview',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
export function getSalesService(data) {
    return apiService({
        method: 'POST',
        url: '/dashboard/sales',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
export function getOrdersService(data) {
    return apiService({
        method: 'POST',
        url: '/dashboard/orders',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
